import { jsx as _jsx } from "react/jsx-runtime";
import { Notice } from "@sundae/ui-toolkit";
export const FormError = ({ context, error }) => context === error?.context ? (_jsx(Notice, { type: "error", className: "mt-2", size: "sm", children: error?.message })) : null;
//# sourceMappingURL=FormError.js.map